import { BOX_SLOT_PARTICIPANTS_LIMIT_MAX, BOX_SLOT_PARTICIPANTS_LIMIT_MIN } from "@modules/boxSlot/boxSlotTypes"
import { type Weekdays } from "@modules/boxSlotTemplate/boxSlotTemplateTypes"
import { word } from "@modules/core/utils/i18n"
import dayjs from "dayjs"
import * as Yup from "yup"

export type BoxSlotTemplateGroupInputKey =
  | "boxProgramId"
  | "participantLimit"
  | "slotDuration"
  | "limitStart"
  | "limitEnd"
  | "limitCancel"
  | "location"
  | "allowMultiBooking"
  | "slotTemplates"
  | `${string}.startTime`
  | `${string}.endTime`
  | "assignedStaffMembers"
  | "dropinsAccepted"
  | "trialsAccepted"

export type BoxSlotTemplateRangeFormikType = {
  index: number
  weekDay: Weekdays
  startTime: Date
  endTime: Date
}

export function getValidationSchema() {
  return Yup.object({
    boxProgramId: Yup.string().required(word("global.form.required")),
    slotDuration: Yup.number()
      .min(1, word("global.form.minimumValue", { minValue: 1 }))
      .required(word("global.form.required")),
    participantLimit: Yup.number()
      .required(word("global.form.required"))
      .min(
        BOX_SLOT_PARTICIPANTS_LIMIT_MIN,
        word("global.form.minimumValue", { minValue: BOX_SLOT_PARTICIPANTS_LIMIT_MIN }),
      )
      .max(
        BOX_SLOT_PARTICIPANTS_LIMIT_MAX,
        word("global.form.maximumValue", { maxValue: BOX_SLOT_PARTICIPANTS_LIMIT_MAX }),
      ),
    slotTemplatesRanges: Yup.array()
      .of(
        Yup.object({
          weekDay: Yup.string().required(word("global.form.required")).trim(),
          startTime: Yup.date().required(word("global.form.required")),
          endTime: Yup.date().required(word("global.form.required")),
        }).test("slotTemplateRange", word("box.slotTemplateGroup.form.registration.end_error"), (value) => {
          return value.startTime !== null && value.endTime !== null && dayjs(value.startTime).isBefore(value.endTime)
        }),
      )
      .min(1, word("box.slotTemplateGroup.form.validation.missingRange"))
      .required(),
    location: Yup.string()
      .trim()
      .nullable()
      .max(40, word("form.maximum.characters", { count: 40 })),
    limitStart: Yup.number()
      .min(1, word("global.form.minimumValue", { minValue: 1 }))
      .required(word("global.form.required")),
    limitEnd: Yup.number()
      .min(1, word("global.form.minimumValue", { minValue: 1 }))
      .test("limitEnd", word("box.slotTemplateGroup.form.registration.end_error"), (value, context) => {
        return context.parent.limitStart !== null && !!value && context.parent.limitStart > value
      }),
    limitCancel: Yup.number()
      .min(1, word("global.form.minimumValue", { minValue: 1 }))
      .required(word("global.form.required")),
    allowMultiBooking: Yup.boolean().nullable(),
    assignedStaffMembers: Yup.array(),
    dropinsAccepted: Yup.boolean().nullable(),
    trialsAccepted: Yup.boolean().nullable(),
  })
}
